import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes, instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import CookieStorageService from '../../services/CookieStorageService';
import { LOGIN_TEXT, LOGIN_FAILURE, LOGIN_FORM_CLASSNAME,
    LOGIN_FORM_CLASSNAME_FAILURE, LOGIN_TEXT_CLASSNAME,
    LOGIN_TEXT_CLASSNAME_FAILURE }
    from '../../constants/bsauth_login_constants';
import { BSAUTH_COOKIE } from '../../constants/cookie_constants';
import { LOGIN_TOKEN_TYPE_BSAUTH, LOGIN_TOKEN_TYPE_COOKIE } from '../../constants/cookie_constants';
import BSAuthService from '../../services/BSAuthService';
import * as session_handlers from '../../actions/session_handler';
import './BSAuthLogin.css';


const getInitialState = () => ({
    error: false,
    errorMsg: '',
    username: '',
    password: ''
});

const EMAIL_LABEL = 'Email Address';
const PASSWORD_LABEL = 'Password';

class BSAuthLogin extends Component {
    constructor (props) {
        super(props);
        this.state = getInitialState();
        this.login = this.login.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
    }

    login(evt) {
        evt.preventDefault();
        BSAuthService.login(this.state.email, this.state.password)
            .then((bsAuthToken) => {
                CookieStorageService.set(BSAUTH_COOKIE, bsAuthToken, this.props.cookies);
                CookieStorageService.set(LOGIN_TOKEN_TYPE_COOKIE, LOGIN_TOKEN_TYPE_BSAUTH, this.props.cookies);
                this.props.updateLoginSession(true, LOGIN_TOKEN_TYPE_BSAUTH);
            })
            .catch((error) => {
                this.setState({ error: true, errorMsg: error });
            });
    }

    handleEmailChange(evt) {
        this.setState(Object.assign({}, this.state,
            { email: evt.target.value, error: false, errorMsg: '' }));
    }

    handlePasswordChange(evt) {
        this.setState(
            Object.assign({}, this.state,
                {password: evt.target.value, error: false, errorMsg: '' }));
    }

    render() {
        const { isUserLoggingIn } = this.props;
        const enableLogin =
            !this.state.email || !this.state.password || this.state.error;

        let loginText, loginFormClassName, loginTextClassName;
        if (this.state.error){
            loginText = LOGIN_FAILURE;
            loginFormClassName = LOGIN_FORM_CLASSNAME_FAILURE;
            loginTextClassName = LOGIN_TEXT_CLASSNAME_FAILURE;
        } else {
            loginText = LOGIN_TEXT;
            loginFormClassName = LOGIN_FORM_CLASSNAME;
            loginTextClassName = LOGIN_TEXT_CLASSNAME;
        }

        return (
            <div id="bitstrips-login-container"
                 className={ isUserLoggingIn ? 'bs-auth-container-logging-in' : 'bs-auth-container'}>
                <div className={loginTextClassName}>
                    <p>{loginText}</p>
                </div>
                <form className="login-form">
                    <div className="email-wrapper">
                        <label htmlFor="bitstrips-email-address">{EMAIL_LABEL}</label>
                        <input className={loginFormClassName} id="bitstrips-email-address"
                               type="email" placeholder={EMAIL_LABEL}
                               onChange={this.handleEmailChange} />
                        <span className="email-icon"></span>
                    </div>
                    <div className="password-wrapper">
                        <label htmlFor="bitstrips-password">{PASSWORD_LABEL}</label>
                        <input className={loginFormClassName}
                               type="password" placeholder={PASSWORD_LABEL} id="bitstrips-password"
                               onChange={this.handlePasswordChange} />
                        <span className="password-icon"></span>
                    </div>
                    <input type="submit" name="submit" id="bitstrips-login" value="Log In" onClick={this.login}
                           disabled={enableLogin} />
                </form>
            </div>
        );
    }
}

BSAuthLogin.propTypes = {
    isUserLoggingIn: PropTypes.bool.isRequired,
    updateLoginSession: PropTypes.func.isRequired,
    cookies: instanceOf(Cookies).isRequired
};

export default connect(state => ({
    session: state.sessionReducer
}), session_handlers)(withCookies(BSAuthLogin));




// WEBPACK FOOTER //
// ./src/components/login_view/BSAuthLogin.js